import App from "./shopping-list/App.svelte"

let shoppingListApp: App | null = null

const mount = () => {
  destroy()

  const root = document.querySelector("#shopping-list-app")

  if (root === null) return

  const initialData = JSON.parse(root.dataset.initialData)

  shoppingListApp = new App({
    target: root,
    props: {
      initialData
    }
  })
}

const destroy = () => {
  if (shoppingListApp) {
    shoppingListApp.$destroy()
    shoppingListApp = null
  }
}

document.addEventListener("turbo:load", mount)
document.addEventListener("turbo:before-cache", destroy)
